import { Link } from 'react-router-dom';
import styled from 'styled-components';

import colors from '../../../../assets/theme/colors';

export const BoxLinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const LinkWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 0px;
`;
export const WrapperLogo = styled.div`
  display: block;
`;
export const LinkLogo = styled.img`
  display: block;
  width: 22px;
  height: auto;
`;
export const Links = styled(Link)`
  font-size: 16px;
  letter-spacing: 0.65px;
  line-height: 140%;
  display: block;
  color: ${colors.menuColor};
  text-decoration: none;
  font-weight: 400;
`;
